<div class="img-select img-round-container" [class.error-img]="error">
    <img src="assets/img/intern/icons/menus/gallery.svg" alt="galery" class="gallery" id="img">
    <input (change)="newImg($event);imgInput.value='';" type="file" class="m-0" [multiple]="multiple" #imgInput>
    <img [src]="tempImg?tempImg:(img | img: (type==='elaborations'?'recipes':type))" [alt]="type + ' img'" class="img-content">
</div>